import React from 'react';

const UserProfile = React.lazy(
  () => import('./components/accounts/UserProfile'),
);
const ChangePassword = React.lazy(
  () => import('./components/accounts/ChangePassword'),
);
const Page404 = React.lazy(() => import('./components/views/Page404'));
const Login = React.lazy(() => import('./components/auth/Login'));
const ForgotPassword = React.lazy(
  () => import('./components/auth/ForgotPassword'),
);
const Logout = React.lazy(() => import('./components/auth/Logout'));
const AccountDetail = React.lazy(
  () => import('./components/views/AccountDetail'),
);
const AttorneyProfile = React.lazy(
  () => import('./components/attorneys/AttorneyProfile'),
);
const RedirectionComp = React.lazy(
  () => import('./components/common/RedirectionComp'),
);
// import Home from './components/views/Home';
const UpdateAttorneyWrapper = React.lazy(
  () => import('./components/attorneys/update-attorney/UpdateAttorneyWrapper'),
);
const ResetPassword = React.lazy(
  () => import('./components/auth/ResetPassword'),
);
const AttorneyRegistrationWrapper = React.lazy(
  () =>
    import(
      './components/attorneys/register-attorney/AttorneyRegistrationWrapper'
    ),
);
const ChangeTemporaryPassword = React.lazy(
  () => import('./components/accounts/ChangeTemporaryPassword'),
);
const FindAnAttorneyWrapper = React.lazy(
  () => import('./components/attorneys/find-attorney/FindAnAttorneyWrapper'),
);
const AttorneyDirecotory = React.lazy(
  () => import('./components/attorneys/find-attorney/AttorneyDirectory'),
);

const routes = [
  { path: '/', exact: true, name: 'Home', component: RedirectionComp },
  // { path: '/', exact: true, name: 'Home', component: Home },
  {
    path: '/attorney-registration//*',
    name: 'Attorney Registration',
    component: AttorneyRegistrationWrapper,
  },
  {
    path: '/complete-profile//*',
    name: 'Update An Attorney',
    component: UpdateAttorneyWrapper,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/forgot-password',
    name: 'Forgot Password',
    component: ForgotPassword,
  },
  {
    path: '/reset-password',
    name: 'Reset Password',
    component: ResetPassword,
  },
  {
    path: '/account-details',
    name: 'Account Detail',
    component: AccountDetail,
  },
  {
    path: '/profile',
    exact: true,
    name: 'User Profile',
    component: UserProfile,
  },
  {
    path: '/change-password',
    exact: true,
    name: 'Change Password',
    component: ChangePassword,
  },
  {
    path: '/change-temporary-password',
    exact: true,
    name: 'Change Temporary Password',
    component: ChangeTemporaryPassword,
  },
  {
    path: '/logout',
    exact: true,
    name: 'Logout',
    component: Logout,
  },
  {
    path: '/find-an-attorney//*',
    name: 'Find An Attorney',
    component: FindAnAttorneyWrapper,
  },
  {
    path: '/attorney-directory',
    name: 'Attorney Directory',
    component: AttorneyDirecotory,
  },
  {
    path: '/attorney-directory/:id',
    name: 'Attorney Profile',
    component: AttorneyProfile,
  },
  { path: '*', name: 'page-404', component: Page404 },
];

export default routes;
